export const ghElementSettingsDictionary = [
  {
    key: 'field_name',
    en: 'Field Name',
    uk: 'Назва поля',
    de: 'Feldname',
    fr: 'Nom du champ'
  },
  {
    key: 'name_space',
    en: 'Name space',
    uk: 'Простір імен',
    de: 'Namensraum',
    fr: 'Espace de noms'
  },
  {
    key: 'activate',
    en: 'Activate',
    uk: 'Активувати',
    de: 'Aktivieren',
    fr: 'Activer'
  },
  {
    key: 'code_editor',
    en: 'Code Editor',
    uk: 'Редактор коду',
    de: 'Code-Editor',
    fr: 'Éditeur de code'
  },
  {
    key: 'source_place',
    en: 'Source place',
    uk: 'Місце джерела',
    de: 'Quellort',
    fr: 'Emplacement source'
  },
  {
    key: 'editable',
    en: 'Editable',
    uk: 'Редагований',
    de: 'Bearbeitbar',
    fr: 'Modifiable'
  },
  {
    key: 'disable',
    en: 'Disable',
    uk: 'Вимкнути',
    de: 'Deaktivieren',
    fr: 'Désactiver'
  },
  {
    key: 'show_field',
    en: 'Show field',
    uk: 'Показати поле',
    de: 'Feld anzeigen',
    fr: 'Afficher le champ'
  },
  {
    key: 'condition_filter',
    en: 'Use Condition Filter',
    uk: 'Фільтр умов',
    de: 'Bedingungsfilter',
    fr: 'Filtre de condition'
  },
  {
    key: 'font_size',
    en: 'Font Size',
    uk: 'Розмір шрифту',
    de: 'Schriftgröße',
    fr: 'Taille de police'
  },
  {
    key: 'font_color',
    en: 'Font Color',
    uk: 'Колір шрифту',
    de: 'Schriftfarbe',
    fr: 'Couleur de police'
  },
  {
    key: 'display_icon',
    en: 'Display icon',
    uk: 'Показати іконку',
    de: 'Symbol anzeigen',
    fr: 'Afficher l\'icône'
  },
  {
    key: 'icon_color',
    en: 'Icon Color',
    uk: 'Колір іконки',
    de: 'Symbolfarbe',
    fr: 'Couleur de l\'icône'
  },
  {
    key: 'icon',
    en: 'Icon',
    uk: 'Іконка',
    de: 'Symbol',
    fr: 'Icône'
  },
  {
    key: 'show_field_name',
    en: 'Show field name',
    uk: 'Показати назву поля',
    de: 'Feldname anzeigen',
    fr: 'Afficher le nom du champ'
  },
  {
    key: 'field_settings',
    en: 'Field Settings',
    uk: 'Налаштування поля',
    de: 'Feldeinstellungen',
    fr: 'Paramètres du champ'
  },
  {
    key: 'general_settings',
    en: 'General settings',
    uk: 'Загальні налаштування',
    de: 'Allgemeine Einstellungen',
    fr: 'Paramètres généraux'
  },
  {
    key: 'field_style',
    en: 'Field Style',
    uk: 'Стиль поля',
    de: 'Feldstil',
    fr: 'Style du champ'
  },
  {
    key: 'alignment',
    en: 'Alignment',
    uk: 'Вирівнювання',
    de: 'Ausrichtung',
    fr: 'Alignement'
  },
  {
    key: 'field_name_style',
    en: 'Field Name Style',
    uk: 'Стиль назви поля',
    de: 'Feldnamenstil',
    fr: 'Style du nom du champ'
  },
  {
    key: 'interpretation_type',
    en: 'Interpretation type',
    uk: 'Тип інтерпретації',
    de: 'Interpretationstyp',
    fr: 'Type d\'interprétation'
  },
  {
    key: 'options',
    en: 'Settings',
    uk: 'Параметри',
    de: 'Optionen',
    fr: 'Options'
  },
  {
    key: 'help',
    en: 'Help',
    uk: 'Допомога',
    de: 'Hilfe',
    fr: 'Aide'
  },
  {
    key: 'style',
    en: 'Style',
    uk: 'Стиль',
    de: 'Stil',
    fr: 'Style'
  },
  {
    key: 'embed',
    en: 'Embed',
    uk: 'Вбудувати',
    de: 'Einbetten',
    fr: 'Intégrer'
  },
  {
    key: 'code',
    en: 'Code',
    uk: 'Код',
    de: 'Code',
    fr: 'Code'
  },
  {
    key: 'automation',
    en: 'Automation',
    uk: 'Автоматизація',
    de: 'Automatisierung',
    fr: 'Automatisation'
  },
  {
    key: 'top',
    en: 'Top',
    uk: 'Зверху',
    de: 'Oben',
    fr: 'Haut'
  },
  {
    key: 'left',
    en: 'Left',
    uk: 'Зліва',
    de: 'Links',
    fr: 'Gauche'
  },
  {
    key: 'bottom',
    en: 'Bottom',
    uk: 'Знизу',
    de: 'Unten',
    fr: 'Bas'
  },
];
